import * as Icons from "heroicons-react";
import { useCSVReader } from "react-papaparse";
import { useDispatch } from "react-redux";
import { selectcsvData } from "../../../features/importSlice";
import "./CsvImpoter.css";

const styles = {
  csvReader: {
    display: "flex",
    flexDirection: "row",
    marginBottom: 10,
  },
  browseFile: {
    // width: '20%',
  },
  acceptedFile: {
    border: "1px solid #ccc",
    height: 45,
    lineHeight: 2.5,
    paddingLeft: 10,
    // width: '80%',
  },
  remove: {
    borderRadius: 0,
    // padding: '0 20px',
  },
  progressBarBackgroundColor: {
    backgroundColor: "black",
  },
};

const CsvDataImporter = () => {
  const dispatch = useDispatch();
  const { CSVReader } = useCSVReader();

  return (
    <CSVReader
      onUploadAccepted={(results) => {
        console.log("results", results);
        console.log("---------------------------");
        const rawData = results?.data || [];
        const normalizedData = rawData
          .map((item) => {
            if (!item || typeof item !== "object") return null;
            const normalized = {};
            Object.keys(item).forEach((key) => {
              const cleanKey = key?.trim()?.replace(/^\ufeff/, "");
              normalized[cleanKey] =
                typeof item[key] === "string" ? item[key].trim() : item[key];
            });
            return normalized;
          })
          .filter(
            (item) =>
              item &&
              (item.article_code ||
                item.name ||
                item.Article_Code ||
                item["Article Code"] ||
                Object.values(item).some((v) => v !== "" && v !== null && v !== undefined))
          );
        dispatch(selectcsvData(normalizedData));
        console.log("Accepted Products:", normalizedData.length);
        console.log("---------------------------");
      }}
      config={{ header: true, skipEmptyLines: true }}
    >
      {({ getRootProps, acceptedFile, ProgressBar, getRemoveFileProps }) => (
        <>
          <div className="row mt-3 gx-0  align-items-center">
            <div className="col-12">
              <div class="input-group ">
                <span class="input-group-text">
                  <button
                    type="button"
                    {...getRootProps()}
                    className=" btn btn-dark btn-block"
                    style={{ zIndex: 0 }}
                  >
                    Browse Csv
                  </button>
                </span>
                <input
                  type="text"
                  className="form-control"
                  value={acceptedFile ? acceptedFile.name : "No File Selected"}
                  aria-describedby="basic-addon1"
                  id=""
                />
                <span class="input-group-text">
                  <span class="input-group-text" id="basic-addon1">
                    <button
                      {...getRemoveFileProps()}
                      className="btn btn-outline-dark btn-block"
                      style={{ zIndex: 0 }}
                    >
                      <Icons.X size="16" />
                    </button>
                  </span>
                </span>
              </div>
            </div>

            <div className="col-12">
              <ProgressBar />
            </div>
          </div>
        </>
      )}
    </CSVReader>
  );
};

export default CsvDataImporter;
